import React from 'react';
import Logo from '../../../shared/components/ui/Logo';

/**
 * Kridah logo watermark for tactics charts.
 * Centered, overlapping the top of the pitch canvas so it hovers over the field (included in exported image).
 */
const TacticsWatermark: React.FC = () => {
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 top-16 z-10 flex justify-center items-center opacity-90 pointer-events-none rounded-lg border border-gray-400 px-2 py-1 bg-white/95"
      aria-hidden
    >
      <Logo variant="full" size="md" className="h-9 max-h-9 w-auto" />
    </div>
  );
};

export default TacticsWatermark;
